const carbonSections = {
    content: { key: 'cartable', name: '{{lang}}Cartable', img: '/images/icons/layout.png' },

    // category: { key: 'category', name: 'Categories options', },
    // blog: { key: 'blog', name: 'blogs options', },
    // video: { key: 'video', name: 'videos options', },
    // podcast: { key: 'podcast', name: 'podcasts options', },
    // series: { key: 'series', name: 'series options', },



    // froum: { key: 'settings', name: 'تنطیمات پایه', img: '/images/icons/settings.png' },

    // admin: { key: 'report', name: 'گزارش درخواست ها', img: '/images/icons/file.png' },

    // categories: { key: 'operation', name: 'عملیات', img: '/images/icons/computer.png' },




    // product: { key: 'products', name: 'Products option' },
    // messages: { key: 'messages', name: 'messages option' }
}

const carbonPages = {


    adminLogs: {
        key: "adminLogs",
        title: '{{lang}}Admin Logs',
        description: 'Admin Logs List',
        fetchUrl: 'getLogs',
        // addUrl: 'addEmployee',
        // editUrl: 'addEmployee',
        // removeUrl: 'removeEmployee',
        pageType: 'form',
        page: 'logs',
        parent: 'whthoutParent',
        postBody: {},

        addNew: -1,
        options: { noAddNew: true },
        actions: {
            edit: { key: "edit", label: '{{lang}}view', color: '#F87C56', function: "openEditModal", permission: 'view' },
        },
        // tabs: [
        //     { title: 'Admins', filter: { "role": 'admin' } },
        //     { title: 'Users', filter: { "role": 'user' } },

        // ],

        image: '/images/icons/log.png',
        headers: [
            { type: 'TextInput', key: 'name', information: { label: '{{lang}}Name', disabled: true }, showMain: true },
            { type: 'TextInput', key: 'phone', information: { label: '{{lang}}Phone', disabled: true }, showMain: true },
            { type: 'TextInput', key: 'committer', information: { label: '{{lang}}committed by', disabled: true }, showMain: true },
            { type: 'TextInput', key: 'ip', information: { label: '{{lang}}ip', disabled: true }, showMain: true },
            { type: 'TextAreaInput', key: 'message', information: { label: '{{lang}}Message', disabled: true }, showMain: true },
            { type: 'DateInput', key: 'cDate', information: { label: '{{lang}}Date/Time', time: true, disabled: true }, showMain: true },

            { type: 'TextInput', key: 'type', information: { label: '{{lang}}Type', disabled: true }, showMain: true },

        ],
    },
    mydocuments: {
        key: 'mydocuments',
        title: '{{lang}}My Documents',
        description: '{{lang}}My Documents list',
        fetchUrl: 'getMyDocuments',
        // addUrl: 'categoryAdd',
        // editUrl: 'categoryAdd',
        // removeUrl: 'removeCategory',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'cartable',
        options: {},
        // sort: { 'cDate': -1 },
        addNew: '/admin/mydocumentsInfo',
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: 'عنوان درخواست', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
            { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
            { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: true },
        ],

    },
    mydocumentsInfo: {
        key: 'mydocumentsInfo',
        title: '{{lang}}My Documents',
        description: '{{lang}}My Documents list',
        fetchUrl: 'getOneDocument',
        // addUrl: 'categoryAdd',
        // editUrl: 'categoryAdd',
        // removeUrl: 'removeCategory',
        // parentSection: 'mydocuments',

        actions: {
            edit: { key: "edit", label: '{{lang}}مجوز ویرایش درخواست', color: '#F87C56', function: "openEditModal" },
            mandatory: { key: "mandatory", label: '{{lang}}اجباری بودن تایید مشورت دهندگان جهت تایید', color: '#F87C56', function: "" },
            done: { key: "done", label: '{{lang}}خاتمه درخواست در صورت رد کردن', color: '#F87C56', function: "" },
            review: { key: "review", label: '{{lang}}مجوز ارسال به مرحله قبل جهت بازبینی', color: '#F87C56', function: "" },
            notification: { key: "notification", label: '{{lang}}مجوز ارسال جهت اطلاع', color: '#F87C56', function: "" },
            attachment: { key: "attachment", label: '{{lang}}مجوز اصلاق پیوست', color: '#F87C56', function: "" },
            effectOfChange: { key: "effectOfChange", label: '{{lang}}مجوز تعیین اثر تغییر بر مدرک مرتبط', color: '#F87C56', function: "" },
            consultation: { key: "consultation", label: '{{lang}}مجوز دربافت مشورت', color: '#F87C56', function: "" },
        },
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'AdminSectionFormApplet',
        parent: 'cartable',
        options: {},
        // sort: { 'cDate': -1 },
        addNew: -1,
        hidePage: true,
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        sections: [
            {
                title: "{{lang}}مدرک", key: 'document',
                headers: [
                    { col: '6', key: 'name', type: 'TextInput', information: { label: 'عنوان درخواست', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
                    { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
                    { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
                    { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
                    { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
                ]
            },
        ],
        headers: [
            { col: '6', type: 'SelectInput', key: 'initStatus', information: { label: 'وضعیت', type: 'local', items: [{ value: 'submit', title: 'تایید' }, { value: 'reject', title: 'رد' }, { value: 'edit', title: 'نیاز به اصلاح' }], isSearchable: true, placeholder: 'انتخاب وضعیت', required: true }, showMain: true },

            // { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
            // { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
            // { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            // { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: true },
        ],

    },

    myRecords: {
        key: 'myRecords',
        title: '{{lang}}My Records',
        description: '{{lang}}My Records list',
        fetchUrl: 'getMyRecord',
        // addUrl: 'categoryAdd',
        // editUrl: 'categoryAdd',
        // removeUrl: 'removeCategory',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'cartable',
        // options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        addNew: '/admin/recordInfo',
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
            { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
        ],

    },

    recordInfo: {
        key: 'recordInfo',
        title: '{{lang}}My Records',
        description: '{{lang}}My Records list',
        fetchUrl: 'getOneMyRecord',
        // addUrl: 'categoryAdd',
        // editUrl: 'categoryAdd',
        // removeUrl: 'removeCategory',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'AdminSectionFormApplet',
        parent: 'cartable',
        // options: {},
        hidePage: true,
        // sort: { 'cDate': -1 },
        addNew: -1,
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        sections: [
            {
                title: "{{lang}}سابقه", key: 'record',
                headers: [
                    { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
                    { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
                    { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
                    { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
                    { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
                ]
            },
        ],
        headers: [
            // { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
            // { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            // { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            // { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
        ],

    },

    documentsorinformation: {
        key: 'documentsorinformation',
        title: '{{lang}}Documents for Information',
        description: '{{lang}}Documents for Information list',
        fetchUrl: 'getAllCategory',
        addUrl: 'categoryAdd',
        editUrl: 'categoryAdd',
        removeUrl: 'removeCategory',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'cartable',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/doc.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
            { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
            // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
            { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

            // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
        ],

    },
    documentsorconsultation: {
        key: 'documentsorconsultation',
        title: '{{lang}}Documents for consultation',
        description: '{{lang}}Documents for consultation list',
        fetchUrl: 'getAllCategory',
        addUrl: 'categoryAdd',
        editUrl: 'categoryAdd',
        removeUrl: 'removeCategory',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'cartable',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/userdoc.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
            { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
            // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
            { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

            // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
        ],

    },


    // chart: {
    //     key: 'chart',
    //     title: 'چارت سازمانی',
    //     description: 'لیست چارت سازمانی',
    //     fetchUrl: 'getChart',
    //     addUrl: 'postChart',
    //     editUrl: 'postChart',
    //     removeUrl: 'removeChart',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'tree',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/orgchart.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'parent', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getChart', filter: {} }, settings: { required: true }, showMain: true },
    //     ],

    // },

    // jobs: {
    //     key: 'jobs',
    //     title: 'شغل ها',
    //     description: 'لیست شغل ها',
    //     fetchUrl: 'getJobs',
    //     addUrl: 'postJobs',
    //     editUrl: 'postJobs',
    //     removeUrl: 'removeJobs',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'tree',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/job.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'jobChart', col: '6', information: { label: 'چارت سازمانی', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getChart', filter: {}, required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'parent', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
    //     ],

    // },

    // users: {
    //     key: 'users',
    //     title: 'مدیریت کاربران',
    //     description: 'لیست کاربران',
    //     fetchUrl: 'employeeGetAll',
    //     addUrl: 'employeeAdd',
    //     editUrl: 'employeeAdd',
    //     removeUrl: 'employeeRemove',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/users.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'number', type: 'TextInput', information: { label: '{{lang}}Number', disabled: true, required: false }, showMain: true, inExport: false },
    //         { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'email', type: 'TextInput', information: { label: '{{lang}}Email', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'password', type: 'TextInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: true },
    //         { type: 'MultiSelectInput', key: 'jobs', col: '12', information: { label: 'شغل ها', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },

    //     ],

    // },

    // processes: {
    //     key: 'processes',
    //     title: 'فرایند ها',
    //     description: 'لیست فرایند ها',
    //     fetchUrl: 'getProcesses',
    //     addUrl: 'postProcesses',
    //     editUrl: 'postProcesses',
    //     removeUrl: 'removeProcesses',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'tree',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/process.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'parent', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getProcesses', filter: {} }, settings: { required: true }, showMain: true },
    //     ],

    // },
    // distributionlist: {
    //     key: 'distributionlist',
    //     title: 'لیست توزیع',
    //     description: 'لیست توزیع',
    //     fetchUrl: 'getDistributionList',
    //     addUrl: 'postDistributionList',
    //     editUrl: 'postDistributionList',
    //     removeUrl: 'removeDistributionList',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'tree',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/list.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}name', placeholder: 'لطفا نام فرایند را وارد کنید', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
    //         { type: 'MultiSelectInput', key: 'users', col: '6', information: { label: 'کاربران', type: 'api', fields: { value: '_id', title: 'name' }, address: 'employeeGetAll', filter: {} }, settings: { required: true }, showMain: true },
    //     ],

    // },
    // workflowpattern: {
    //     key: 'workflowpattern',
    //     title: 'الگوی گردش کار',
    //     description: 'لیست الگوی گردش کار',
    //     fetchUrl: 'getWorkflow',
    //     addUrl: 'postWorkflow',
    //     editUrl: 'postWorkflow',
    //     removeUrl: 'removeWorkflow',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/planning.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'number', type: 'TextInput', information: { label: 'شماره', disabled: true, required: false }, showMain: true, inExport: true },
    //         {
    //             type: 'SubformInput',
    //             key: 'step',
    //             col: '12',
    //             information: {
    //                 headers: [
    //                     { type: 'SelectInput', key: 'inCharge', col: '4', information: { label: 'مسئول', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getResponsibilities', filter: {} }, settings: { required: true }, showMain: true },
    //                     { type: 'SelectInput', key: 'user', col: '4', information: { label: 'کاربران', type: 'api', fields: { value: '_id', title: 'name' }, address: 'employeeGetAll', filter: {} }, settings: { required: true }, showMain: true },
    //                     { type: 'MultiSelectInput', key: 'settings', col: '4', information: { label: 'مجوز ها', type: 'local', items: [{ value: 'mandatory', title: 'اجباری بودن تایید مشورت دهندگان جهت تایید' }, { value: 'done', title: 'خاتمه درخواست در صورت رد کردن' }, { value: 'review', title: 'مجوز ارسال به مرحله قبل جهت بازبینی' }, { value: 'notification', title: 'مجوز ارسال جهت اطلاع' }, { value: 'attachment', title: 'مجوز اصلاق پیوست' }, { value: 'effectOfChange', title: 'مجوز تعیین اثر تغییر بر مدرک مرتبط' }, { value: 'consultation', title: 'مجوز دربافت مشورت' }, { value: 'edit', title: 'مجوز ویرایش درخواست' }], isSearchable: true, placeholder: 'انتخاب مجوز ها', required: true }, showMain: true },
    //                 ],
    //                 generateId: true,
    //                 placeholder: '{{lang}}placeholders.insertInformation',
    //                 required: true,
    //             },
    //             showMain: false
    //         },
    //     ],

    // },
    // documentgroup: {
    //     key: 'documentgroup',
    //     title: 'گروه مدارک',
    //     description: 'لیست گروه مدارک',
    //     fetchUrl: 'getDocumentGroup',
    //     addUrl: 'postDocumentGroup',
    //     editUrl: 'postDocumentGroup',
    //     removeUrl: 'removeDocumentGroup',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/documents.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '12', key: 'code', type: 'GenerateCodeInput', information: { label: 'کد', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDocumentGroup', filter: {} }, settings: { required: true }, showMain: true },
    //         { col: '6', key: 'split', type: 'TextInput', information: { label: 'جدا کننده', disabled: false, required: true }, showMain: true, inExport: true },
    //         {
    //             type: 'SubformInput',
    //             key: 'distributionList',
    //             col: '12',
    //             information: {
    //                 headers: [
    //                     { type: 'SelectInput', key: 'distribution', col: '4', information: { label: 'لیست توزیع', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {} }, settings: { required: true }, showMain: true },
    //                     { type: 'MultiSelectInput', key: 'settings', col: '4', information: { label: 'مجوز ها', type: 'local', items: [{ value: 'downloadAndPrint', title: 'مجوز دانلود و چاپ مدرک' }, { value: 'downloadAndEdit', title: 'مجوز دانلود نسخه قابل ویرایش' }, { value: 'print', title: 'مجوز چاپ مدرک' }, { value: 'edit', title: 'مجوز ویرایش مدرک' }, { value: 'remove', title: 'مجوز حذف مدرک' }], isSearchable: true, placeholder: 'انتخاب مجوز ها', required: false }, showMain: true },
    //                     { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, placeholder: 'این کد به صورت سیستمی ساخته می شود' }, showMain: false, inExport: true },
    //                 ],
    //                 placeholder: '{{lang}}placeholders.insertInformation',
    //                 required: true,
    //             },
    //             showMain: false
    //         },
    //         {
    //             type: 'SubformInput',
    //             key: 'usersList',
    //             col: '12',
    //             information: {
    //                 headers: [
    //                     { type: 'MultiSelectInput', key: 'users', col: '4', information: { label: 'کاربران', type: 'api', fields: { value: '_id', title: 'name' }, address: 'employeeGetAll', filter: {} }, settings: { required: false }, showMain: true },
    //                     { type: 'MultiSelectInput', key: 'settings', col: '4', information: { label: 'مجوز ها', type: 'local', items: [{ value: 'downloadAndPrint', title: 'مجوز دانلود و چاپ مدرک' }, { value: 'downloadAndEdit', title: 'مجوز دانلود نسخه قابل ویرایش' }, { value: 'print', title: 'مجوز چاپ مدرک' }, { value: 'edit', title: 'مجوز ویرایش مدرک' }, { value: 'remove', title: 'مجوز حذف مدرک' }], isSearchable: true, placeholder: 'انتخاب مجوز ها', required: false }, showMain: true },
    //                     { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, placeholder: 'این کد به صورت سیستمی ساخته می شود' }, showMain: false, inExport: true },
    //                 ],
    //                 placeholder: '{{lang}}placeholders.insertInformation',
    //                 required: false,
    //             },
    //             showMain: false
    //         },
    //         { type: 'SelectInput', key: 'workflowCreate', col: '6', information: { label: 'الگوی گردش ایجاد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'workflowEdit', col: '6', information: { label: 'الگوی گردش ویرایش', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'workflowRemove', col: '6', information: { label: 'الگوی گردش حذف', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'processes', col: '6', information: { label: 'فرایند ها', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getProcesses', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //     ],

    // },
    // recordsgroup: {
    //     key: 'recordsgroup',
    //     title: 'گروه سوابق',
    //     description: 'لیست گروه سوابق',
    //     fetchUrl: 'getRecordsGroup',
    //     addUrl: 'postRecordsGroup',
    //     editUrl: 'postRecordsGroup',
    //     removeUrl: 'removeRecordsGroup',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/recordsgroup.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getRecordsGroup', filter: {} }, settings: { required: true }, showMain: true },
    //         { col: '6', key: 'split', type: 'TextInput', information: { label: 'جدا کننده', disabled: false, required: true }, showMain: true, inExport: true },
    //         {
    //             type: 'SubformInput',
    //             key: 'distributionList',
    //             col: '12',
    //             information: {
    //                 headers: [
    //                     { type: 'SelectInput', key: 'distribution', col: '4', information: { label: 'لیست توزیع', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {} }, settings: { required: true }, showMain: true },
    //                     { type: 'MultiSelectInput', key: 'settings', col: '4', information: { label: 'مجوز ها', type: 'local', items: [{ value: 'downloadAndPrint', title: 'مجوز دانلود و چاپ مدرک' }, { value: 'downloadAndEdit', title: 'مجوز دانلود نسخه قابل ویرایش' }, { value: 'print', title: 'مجوز چاپ مدرک' }, { value: 'edit', title: 'مجوز ویرایش مدرک' }, { value: 'remove', title: 'مجوز حذف مدرک' }], isSearchable: true, placeholder: 'انتخاب مجوز ها', required: false }, showMain: true },
    //                     { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, placeholder: 'این کد به صورت سیستمی ساخته می شود' }, showMain: false, inExport: true },
    //                 ],
    //                 placeholder: '{{lang}}placeholders.insertInformation',
    //                 required: true,
    //             },
    //             showMain: false
    //         },
    //         {
    //             type: 'SubformInput',
    //             key: 'usersList',
    //             col: '12',
    //             information: {
    //                 headers: [
    //                     { type: 'MultiSelectInput', key: 'users', col: '4', information: { label: 'کاربران', type: 'api', fields: { value: '_id', title: 'name' }, address: 'employeeGetAll', filter: {} }, settings: { required: false }, showMain: true },
    //                     { type: 'MultiSelectInput', key: 'settings', col: '4', information: { label: 'مجوز ها', type: 'local', items: [{ value: 'downloadAndPrint', title: 'مجوز دانلود و چاپ مدرک' }, { value: 'downloadAndEdit', title: 'مجوز دانلود نسخه قابل ویرایش' }, { value: 'print', title: 'مجوز چاپ مدرک' }, { value: 'edit', title: 'مجوز ویرایش مدرک' }, { value: 'remove', title: 'مجوز حذف مدرک' }], isSearchable: true, placeholder: 'انتخاب مجوز ها', required: false }, showMain: true },
    //                     { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, placeholder: 'این کد به صورت سیستمی ساخته می شود' }, showMain: false, inExport: true },
    //                 ],
    //                 placeholder: '{{lang}}placeholders.insertInformation',
    //                 required: false,
    //             },
    //             showMain: false
    //         },
    //         { type: 'SelectInput', key: 'workflowCreate', col: '6', information: { label: 'الگوی گردش ایجاد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'workflowEdit', col: '6', information: { label: 'الگوی گردش ویرایش', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'workflowRemove', col: '6', information: { label: 'الگوی گردش حذف', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getWorkflow', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //         { type: 'SelectInput', key: 'processes', col: '6', information: { label: 'فرایند ها', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getProcesses', filter: {}, required: true }, settings: { required: true }, showMain: true },
    //     ],

    // },
    // documenttype: {
    //     key: 'documenttype',
    //     title: 'نوع مدرک',
    //     description: 'لیست نوع مدرک',
    //     fetchUrl: 'getDocumentType',
    //     addUrl: 'postDocumentType',
    //     editUrl: 'postDocumentType',
    //     removeUrl: 'removeDocumentType',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         // edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/documenttype.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'code', type: 'TextInput', information: { label: '{{lang}}code', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'email', type: 'TextInput', information: { label: '{{lang}}Email', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'password', type: 'TextInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: true },
    //     ],

    // },

    // // AutoGens: {
    // //     key: "AutoGens",
    // //     title: 'AutoGens',
    // //     description: 'AutoGens List',
    // //     fetchUrl: 'getAutoGens',
    // //     addUrl: 'addAutoGen',
    // //     editUrl: 'addAutoGen',
    // //     removeUrl: 'removeAutoGen',
    // //     pageType: 'form',
    // //     page: 'partners',
    // //     parent: 'whthoutParent',
    // //     // addNew: -1,
    // //     options: { noAddNew: true },

    // //     image: '/images/covers/1.jpg',
    // //     headers: [
    // //         { type: 'TextInput', col: '6', key: 'format', information: { label: 'format', }, showMain: true },
    // //         { type: 'TextInput', col: '6', key: 'app', information: { label: 'app', }, showMain: true },
    // //         { type: 'TextInput', col: '6', key: 'resetNum', information: { label: 'resetNum', }, showMain: true },
    // //         { type: 'TextInput', col: '6', key: 'key', information: { label: 'key ', }, showMain: true },
    // //         { type: 'SelectInput', key: 'country', col: '6', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, settings: { required: true }, showMain: false },

    // //         // { type: 'TextInput', col: '6', key: 'email', information: { label: 'Email', }, showMain: false },
    // //         // { type: 'PasswordInput', key: 'password', information: { label: 'Password', }, showMain: false },
    // //         { type: 'DateInput', key: 'updateDate', col: '6', information: { label: 'update Date', time: false }, showMain: true },
    // //         { key: 'number', type: 'NumberInput', col: '6', information: { label: 'Number', }, showMain: false, fullCol: true, inExport: true },

    // //     ],
    // // },

    // responsibilities: {
    //     key: 'responsibilities',
    //     title: 'مسئولیت ها',
    //     description: 'لیست مسئولیت ها',
    //     fetchUrl: 'getResponsibilities',
    //     addUrl: 'postResponsibilities',
    //     editUrl: 'postResponsibilities',
    //     removeUrl: 'removeResponsibilities',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'settings',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/profile.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '12', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //     ],

    // },


    // senttome: {
    //     key: 'senttome',
    //     title: 'ارسالی به من',
    //     description: ' ارسالی به من',
    //     fetchUrl: 'getAllCategory',
    //     addUrl: 'categoryAdd',
    //     editUrl: 'categoryAdd',
    //     removeUrl: 'removeCategory',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'form',
    //     parent: 'report',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/database.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
    //         // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
    //         // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
    //         { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

    //         // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    //     ],

    // },
    // documentcreationrequests: {
    //     key: 'documentcreationrequests',
    //     title: 'درخواست های ایجاد مدرک',
    //     description: ' درخواست های ایجاد مدرک',
    //     fetchUrl: 'getAllCategory',
    //     addUrl: 'categoryAdd',
    //     editUrl: 'categoryAdd',
    //     removeUrl: 'removeCategory',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'form',
    //     parent: 'report',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/database.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
    //         // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
    //         // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
    //         { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

    //         // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    //     ],

    // },
    // requestsfordeletionorediting: {
    //     key: 'requestsfordeletionorediting',
    //     title: 'درخواست های  حذف و یا ویرایش',
    //     description: ' درخواست های  حذف و یا ویرایش',
    //     fetchUrl: 'getAllCategory',
    //     addUrl: 'categoryAdd',
    //     editUrl: 'categoryAdd',
    //     removeUrl: 'removeCategory',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'form',
    //     parent: 'report',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/database.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
    //         // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
    //         // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
    //         { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

    //         // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    //     ],

    // },



    // requesttocreateadocumentoperation: {
    //     key: 'requesttocreateadocumentoperation',
    //     title: 'درخواست ایجاد مدرک',
    //     description: ' درخواست ایجاد مدرک',
    //     fetchUrl: 'getMyCreateDocument',
    //     addUrl: 'postCreateDocument',
    //     editUrl: 'postCreateDocument',
    //     removeUrl: 'removeCreateDocument',
    //     options: { noAddNew: true },
    //     pageType: 'form',
    //     parent: 'operation',
    //     options: {},
    //     // page: 'episodeCategories',
    //     // postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/checked.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: 'عنوان درخواست', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //         { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //         { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
    //         { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //         { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    //     ],

    // },
    // requesttocreatearecordoperation: {
    //     key: 'requesttocreatearecordoperation',
    //     title: 'درخواست ایجاد سابقه',
    //     description: ' درخواست ایجاد سابقه',
    //     fetchUrl: 'getCreateRecord',
    //     addUrl: 'postCreateRecord',
    //     editUrl: 'postCreateRecord',
    //     removeUrl: 'removeCreateRecord',
    //     options: { noAddNew: true },
    //     // pageType: 'tree',
    //     pageType: 'form',
    //     parent: 'operation',
    //     options: {},
    //     // page: 'episodeCategories',
    //     // postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/checked.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //         { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
    //         { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //         { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    //     ],

    // },
    // requesttoeditordeleteoperation: {
    //     key: 'requesttoeditordeleteoperation',
    //     title: 'درخواست ویرایش و یا حذف ',
    //     description: 'درخواست ویرایش و یا حذف ',
    //     fetchUrl: 'getContents',
    //     addUrl: 'postContent',
    //     removeUrl: 'removeContent',
    //     options: { noAddNew: true },
    //     pageType: 'tree',
    //     parent: 'operation',
    //     options: {},
    //     page: 'episodeCategories',
    //     postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/checked.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    //         // { key: 'values.prority', type: 'NumberInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    //         { key: 'values.parent', type: 'SelectInput', information: { label: '{{lang}}Parent', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { page: 'episodeCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },

    //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    //     ],

    // },

    // // whthoutParent // whthoutParent // whthoutParent // whthoutParent // whthoutParent // whthoutParent

    // documents: {
    //     key: 'documents',
    //     title: ' مدارک ',
    //     description: ' مدارک ',
    //     fetchUrl: 'getAllDocument',
    //     addUrl: 'postContent',
    //     removeUrl: 'removeContent',
    //     options: { noAddNew: true },
    //     pageType: 'tree',
    //     parent: 'whthoutParent',
    //     options: {},
    //     showInDashboard: true,
    //     // page: 'episodeCategories',
    //     postBody: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/folder.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    //         // { key: 'values.prority', type: 'NumberInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    //         { key: 'values.parent', type: 'SelectInput', information: { label: '{{lang}}Parent', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { page: 'episodeCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },

    //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    //     ],

    // },
    // recordssearch: {
    //     key: 'recordssearch',
    //     title: 'سوابق',
    //     description: 'سوابق',
    //     fetchUrl: 'getContents',
    //     addUrl: 'postContent',
    //     removeUrl: 'removeContent',
    //     options: { noAddNew: true },
    //     pageType: 'tree',
    //     parent: 'whthoutParent',
    //     options: {},
    //     showInDashboard: true,
    //     page: 'episodeCategories',
    //     postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/folder.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    //         // { key: 'values.prority', type: 'NumberInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    //         { key: 'values.parent', type: 'SelectInput', information: { label: '{{lang}}Parent', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { page: 'episodeCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },

    //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    //     ],

    // },
    // documentsearch: {
    //     key: 'documentsearch',
    //     title: 'جستجو مدرک ',
    //     description: ' جستجو مدرک ',
    //     fetchUrl: 'getContents',
    //     addUrl: 'postContent',
    //     removeUrl: 'removeContent',
    //     options: { noAddNew: true },
    //     pageType: 'tree',
    //     parent: 'whthoutParent',
    //     options: {},
    //     page: 'episodeCategories',
    //     postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/search.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    //         // { key: 'values.prority', type: 'NumberInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    //         { key: 'values.parent', type: 'SelectInput', information: { label: '{{lang}}Parent', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { page: 'episodeCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },

    //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    //     ],

    // },
    // searchrecords: {
    //     key: 'searchrecords',
    //     title: 'جستجو سوابق',
    //     description: 'جستجو سوابق',
    //     fetchUrl: 'getContents',
    //     addUrl: 'postContent',
    //     removeUrl: 'removeContent',
    //     options: { noAddNew: true },
    //     pageType: 'tree',
    //     parent: 'whthoutParent',
    //     options: {},
    //     page: 'episodeCategories',
    //     postBody: { page: 'episodeCategories' },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/search.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    //     headers: [
    //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    //         // { key: 'values.prority', type: 'NumberInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    //         { key: 'values.parent', type: 'SelectInput', information: { label: '{{lang}}Parent', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { page: 'episodeCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },

    //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    //     ],

    // },


    // // packages: {
    // //     key: 'packages',
    // //     title: '{{lang}}Packages',
    // //     description: 'packages List',
    // //     fetchUrl: 'getEPackages',
    // //     addUrl: 'postEPackage',
    // //     editUrl: 'postEPackage',
    // //     removeUrl: 'removeEPackage',
    // //     pageType: 'form',
    // //     parent: 'admin',



    // //     options: {},
    // //     sort: { 'cDate': -1 },
    // //     image: '/images/back1.jpg',
    // //     headers: [
    // //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}insertName', required: true } },
    // //         // { type: 'NumberInput', key: 'capacity', information: { label: '{{lang}}capacity', placeholder: '{{lang}}capacity', required: true }, showMain: true },
    // //         { type: 'NumberInput', key: 'expiryDate', information: { label: '{{lang}}expiryDate', placeholder: '{{lang}}expiryDate', required: true }, showMain: true },
    // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}inser', required: false } },
    // //         { type: 'SwitchInput', key: 'available', col: '6', information: { label: '{{lang}}available', placeholder: '{{lang}}available', default: true, required: false } },
    // //         { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, placeholder: '{{lang}}chooseImage', ratio: '1:1', required: false } },
    // //         { type: 'PriceInput', key: 'sellingPrice', information: { label: '{{lang}}sellingPrice', placeholder: '{{lang}}sellingPrice', required: true, disabled: false } },

    // //         // { key: 'values.parent', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getValuesWithData', filter: { page: 'categories' }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}insert', required: false }, },
    // //     ]
    // // },

    // // vouchers: {
    // //     key: 'vouchers',
    // //     title: '{{lang}}Vouchers',
    // //     description: 'Generated Voucher List',
    // //     fetchUrl: 'getVouchers',
    // //     fetchOne: 'getOneVoucher',

    // //     addUrl: 'addVoucher',
    // //     editUrl: 'addVoucher',
    // //     removeUrl: 'removeVoucher',
    // //     pageType: 'form',
    // //     parent: 'admin',
    // //     // populate: ["category", 'brand'],
    // //     // options: { noAddNew: true },
    // //     // addNew: -1,
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     // tabs: [
    // //     //     { title: 'Not Used', filter: { "status": '0' } },
    // //     //     { title: 'Used', filter: { "status": '1' } },
    // //     // ],


    // //     options: {},
    // //     page: 'vouchers',
    // //     image: '/images/back1.jpg',
    // //     headers: [

    // //         { key: 'id', type: 'TextInput', col: '6', information: { label: 'Voucher Id', disabled: false }, showMain: true, inExport: true },
    // //         { key: 'amount', type: 'NumberInput', col: '6', information: { label: 'Amount(percentage)', }, showMain: true, inExport: true },
    // //         // { key: 'min', type: 'PriceInput', col: '6', information: { label: 'Min Order Amount', }, showMain: true, inExport: true },
    // //         // { key: 'max', type: 'PriceInput', col: '6', information: { label: 'Max Discount', }, showMain: true, inExport: true },
    // //         // { key: 'min', type: 'PriceInput', col: '6', information: { label: 'Minimum Amount', }, showMain: true, inExport: true, showMain: false },
    // //         // { key: 'user', type: 'SelectInput', col: '6', information: { label: 'user', type: 'api', fields: { value: '_id', title: 'company' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, showMain: false },
    // //         // { key: 'user.company', type: 'TextInput', col: '6', information: { label: 'user', type: 'api', }, showMain: true, hideInList: true },
    // //         // { key: 'user.email', type: 'TextInput', col: '6', information: { label: 'email', type: 'api', }, showMain: true, hideInList: true },

    // //         // { type: 'DateInput', key: 'cDate', col: '6', information: { label: 'Create Date', time: false }, showMain: true },
    // //         { type: 'DateInput', key: 'eDate', col: '6', information: { label: 'Expire Date', time: false, startOrEnd: 'end' }, showMain: true },
    // //         // { type: 'DateInput', key: 'uDate', col: '6', information: { label: 'Use Date', time: false }, showMain: true },


    // //         { type: 'SwitchInput', key: 'available', col: '6', information: { label: '{{lang}}available', placeholder: '{{lang}}available', default: true, required: false } },

    // //         // { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Not Used", value: '0' }, { title: 'Used', value: '1' }] }, settings: { required: true }, showMain: true, inExport: true },
    // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: 'Description', }, showMain: false, },


    // //     ]
    // // },

    // // // blogs: {
    // // //     key: 'blogs',
    // // //     title: 'blogs',
    // // //     description: 'blogs list',
    // // //     fetchUrl: 'getBlogs',
    // // //     addUrl: 'postBlog',
    // // //     editUrl: 'postBlog',
    // // //     removeUrl: 'removeBlogs',
    // // //     options: { noAddNew: true },
    // // //     // helperKey: 'values',
    // // //     pageType: 'form',
    // // //     parent: 'content',
    // // //     options: {},
    // // //     // sort: { 'cDate': -1 },
    // // //     // addNew: -1,
    // // //     image: '/images/covers/11.jpg',
    // // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // // //     headers: [
    // // //         { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    // // //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '6', key: 'categories', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // // //         { col: '4', key: 'tags', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
    // // //         { col: '4', key: 'lng', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}lng', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
    // // //         { col: '4', key: 'special', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}special', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
    // // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // // //         { col: '12', key: 'body', type: 'TextAreaInput', information: { label: '{{lang}}content', placeholder: '{{lang}}content', required: true }, showMain: false },
    // // //     ],

    // // // },

    // // // videos: {
    // // //     key: 'videos',
    // // //     title: 'videos',
    // // //     description: 'videos list',
    // // //     fetchUrl: 'getVideos',
    // // //     addUrl: 'postVideo',
    // // //     editUrl: 'postVideo',
    // // //     removeUrl: 'removeVideo',
    // // //     options: { noAddNew: true },
    // // //     // helperKey: 'values',
    // // //     pageType: 'form',
    // // //     parent: 'content',
    // // //     options: {},
    // // //     // sort: { 'cDate': -1 },
    // // //     // addNew: -1,
    // // //     image: '/images/covers/11.jpg',
    // // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // // //     headers: [
    // // //         { col: '12', key: 'video', type: 'FileInput', information: { label: '{{lang}}video', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    // // //         { col: '12', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '12', key: 'thumbnail', type: 'ImageInput', information: { label: '{{lang}}thumbnail', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
    // // //         { col: '6', key: 'series', type: 'MultiSelectInput', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
    // // //         { col: '6', key: 'category', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // // //     ],

    // // // },


    // // series: {
    // //     key: 'series',
    // //     title: '{{lang}}Series',
    // //     description: 'series list',
    // //     fetchUrl: 'getSeries',
    // //     addUrl: 'postSeries',
    // //     editUrl: 'postSeries',
    // //     removeUrl: 'removeSeries',
    // //     options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/faq.jpeg',
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { col: '12', key: 'thumbnail', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
    // //         { col: '12', key: 'teaser', type: 'FileInput', information: { label: '{{lang}}Teaser', placeholder: '{{lang}}choose Teaser', required: false }, showMain: true },
    // //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    // //         { col: '6', key: 'price', type: 'NumberInput', information: { label: '{{lang}}price', disabled: false, required: true }, showMain: true, inExport: true },
    // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'suggestion', title: 'Suggestion' }, { value: 'special', title: 'Special' }], isSearchable: true, placeholder: '{{lang}}special', required: true }, showMain: true },
    // //         // { col: '6', key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}podcast type', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "podcast", value: 'podcast' }, { title: 'video', value: 'video' }, { title: 'text', value: 'text' },], required: true }, showMain: true },
    // //         { col: '6', key: 'category', type: 'SelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: true }, showMain: false },
    // //         // { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
    // //     ],

    // // },
    // // episodes: {
    // //     key: 'episodes',
    // //     title: '{{lang}}Episodes',
    // //     description: 'Episodes list',
    // //     fetchUrl: 'getEpisodesPanel',
    // //     addUrl: 'postEpisode',
    // //     editUrl: 'postEpisode',
    // //     removeUrl: 'removeEpisode',
    // //     options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/15.jpg',
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         // { col: '12', key: 'podcast', type: 'FileInput', information: { label: '{{lang}}podcast', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    // //         { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
    // //         { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: true }, showMain: true, inExport: true },
    // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // //         { col: '12', key: 'series', type: 'MultiSelectInput', information: { label: '{{lang}}Series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}series', required: true }, showMain: true },
    // //         { col: '12', key: 'audio', type: 'FileInput', information: { single: true, label: '{{lang}}صوت زمینه', placeholder: '{{lang}}انتخاب فایل', required: false }, showMain: false },

    // //         // { col: '12', key: 'category', type: 'MultiLevelInput', information: { label: '{{lang}}categories', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { filter:{page: 'episodeCategories'} }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //         { type: 'MultiLevelInput', key: 'category', col: '6', information: { label: '{{lang}}categories', updateAfterSelect: true, isSearchable: true, reference: 'values.parent', root: null, address: 'getContents', filter: { page: "episodeCategories" }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: true },

    // //         { col: '6', type: 'SelectInput', key: 'type', information: { label: '{{lang}}نوع اپیزود', type: 'local', items: [{ value: 'education', title: 'آموزش ها' }, { value: 'chalange', title: 'چالش ها' }], isSearchable: true, placeholder: '{{lang}}special', required: true }, showMain: true },
    // //         {
    // //             key: 'slides',
    // //             type: 'SlidesInput',
    // //             information: {
    // //                 label: '{{lang}}Slides',
    // //                 updateAfterSelect: true,
    // //                 isSearchable: false,
    // //                 fields: { title: 'name', value: '_id' },
    // //                 type: 'api',
    // //                 isSearchable: false,
    // //                 placeholder: '{{lang}}slides',
    // //                 required: false
    // //             },
    // //             dependencies: [{
    // //                 refKey: 'type',
    // //                 targetKey: 'slides',
    // //                 conditions: {
    // //                     root: {
    // //                         id: 'root',
    // //                         action: 'and',
    // //                         conditions: {
    // //                             1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'education' } }
    // //                         }
    // //                     },
    // //                 },
    // //                 show: true,
    // //                 init: true,
    // //                 changeValue: {
    // //                     targetKey: "latitude",
    // //                     value: null,
    // //                     conditions: {
    // //                         root: {
    // //                             id: 'root',
    // //                             action: 'and',
    // //                             conditions: {
    // //                                 1: { id: 1, source: { value: '@data.hasLocation' }, operator: { value: '==' }, target: { value: false } }
    // //                             }
    // //                         },
    // //                     },
    // //                 } //refKey
    // //                 // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    // //             }],
    // //             showMain: false

    // //         },
    // //         {
    // //             key: 'challenges',
    // //             type: 'SlidesChallengeInput',
    // //             information: {
    // //                 label: '{{lang}}Slides',
    // //                 updateAfterSelect: true,
    // //                 isSearchable: false,
    // //                 fields: { title: 'name', value: '_id' },
    // //                 type: 'api',
    // //                 isSearchable: false,
    // //                 placeholder: '{{lang}}slides',
    // //                 required: false
    // //             },
    // //             dependencies: [{
    // //                 refKey: 'type',
    // //                 targetKey: 'challenges',
    // //                 conditions: {
    // //                     root: {
    // //                         id: 'root',
    // //                         action: 'and',
    // //                         conditions: {
    // //                             1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'chalange' } }
    // //                         }
    // //                     },
    // //                 },
    // //                 show: true,
    // //                 init: true,
    // //                 changeValue: {
    // //                     targetKey: "latitude",
    // //                     value: null,
    // //                     conditions: {
    // //                         root: {
    // //                             id: 'root',
    // //                             action: 'and',
    // //                             conditions: {
    // //                                 1: { id: 1, source: { value: '@data.hasLocation' }, operator: { value: '==' }, target: { value: false } }
    // //                             }
    // //                         },
    // //                     },
    // //                 } //refKey
    // //                 // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

    // //             }],
    // //             showMain: false

    // //         },
    // //         // { col: '12', key: 'slides', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },

    // //         // { col: '12', key: 'slides1', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },
    // //         // { col: '12', key: 'slides', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },
    // //         { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
    // //         { col: '6', key: 'locked', type: 'SwitchInput', information: { label: '{{lang}}Locked', disabled: false, required: false }, showMain: true, inExport: true },

    // //         // { col: '6', key: 'category', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //     ],

    // // },


    // // ForumsCategories: {
    // //     key: 'ForumsCategories',
    // //     title: '{{lang}}Forum Categories',
    // //     description: 'categories list',
    // //     fetchUrl: 'getContents',
    // //     addUrl: 'postContent',
    // //     removeUrl: 'removeContent',
    // //     options: { noAddNew: true },
    // //     pageType: 'form',
    // //     parent: 'froum',
    // //     options: {},
    // //     postBody: { page: 'ForumsCategories' },

    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/dashb.jpg',
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


    // //     headers: [
    // //         { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    // //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    // //         { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
    // //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
    // //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
    // //     ],

    // // },


    // // questions: {
    // //     key: 'froum',
    // //     title: '{{lang}}Questions',
    // //     description: 'questions list',
    // //     fetchUrl: 'getQuestions',
    // //     addUrl: 'postQuestion',
    // //     editUrl: 'postQuestion',
    // //     removeUrl: 'removeQuestion',
    // //     options: { noAddNew: false },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'froum',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     addNew: -1,
    // //     image: '/images/covers/8.jpg',
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    // //         { col: '6', key: 'status', type: 'SelectInput', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
    // //         // { col: '6', key: 'category', type: 'SelectInput', information: { label: '{{lang}}getContents', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'ForumsCategories' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //         { col: '6', key: 'category', type: 'SelectInput', information: { label: '{{lang}}categories', updateAfterSelect: true, isSearchable: false, address: 'getContents', filter: { filter: { page: 'ForumsCategories' } }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //         { col: '6', key: 'creator', type: 'SelectInput', information: { disabled: true, label: '{{lang}}creator', updateAfterSelect: true, isSearchable: false, address: 'userGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}creator', required: false }, showMain: true },

    // //         // { col: '6', key: 'votes', type: 'NumberInput', information: { label: '{{lang}}Votes', placeholder: '{{lang}}votes', required: false }, hideComponent: true, showMain: false },
    // //         { col: '6', key: 'answers', type: 'NumberInput', information: { label: '{{lang}}Answers', placeholder: '{{lang}}answers', required: false }, hideComponent: true, showMain: true },
    // //         // { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
    // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
    // //         // { col: '6', key: 'major', type: 'SelectInput', col: '6', information: { label: '{{lang}}رشته ها', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "ریاضی", value: 'ریاضی' }, { title: 'تجربی', value: 'تجربی' }, { title: 'انسانی', value: 'انسانی' },], required: true }, showMain: true },
    // //         // { col: '6', key: 'grade', type: 'SelectInput', information: { label: '{{lang}}مقطع تحصیلی', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "دهم", value: 'دهم' }, { title: 'یازدهم', value: 'یازدهم' }, { title: 'دوازدهم', value: 'دوازدهم' },], required: true }, showMain: false },
    // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true }, showMain: false },
    // //     ],

    // // },


    // // answers: {
    // //     key: 'froum2',
    // //     title: '{{lang}}Answers',
    // //     description: 'answers list',
    // //     fetchUrl: 'getAnswers',
    // //     addUrl: 'postAnswer',
    // //     removeUrl: 'removeAnswer',
    // //     // options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'froum',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     addNew: -1,
    // //     image: '/images/covers/7.jpg',
    // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         // { key: 'question', type: 'TextInput', col: '6', information: { label: '{{lang}}question', placeholder: '{{lang}}question', disabled: false, required: true }, disabled: true, },
    // //         { type: 'SelectInput', key: 'question', col: '6', information: { label: '{{lang}}Question', updateAfterSelect: true, isSearchable: true, address: 'getQuestions', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.questions', required: false }, showMain: true },
    // //         { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
    // //         { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: true }, showMain: true },
    // //         { col: '6', key: 'creator', type: 'SelectInput', information: { disabled: true, label: '{{lang}}creator', updateAfterSelect: true, isSearchable: false, address: 'userGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}creator', required: false }, showMain: true },

    // //         // { key: 'votes', type: 'NumberInput', col: '6', information: { label: '{{lang}}votes', placeholder: '{{lang}}Votes', required: false }, hideComponent: true, disabled: true, showMain: true },
    // //     ],

    // // },


    // // // specifications: {
    // // //     key: 'specifications',
    // // //     title: 'specifications',
    // // //     description: 'Specifications list',
    // // //     fetchUrl: 'getAllSpecifications',
    // // //     addUrl: 'addSpecifications',
    // // //     editUrl: 'addSpecifications',
    // // //     removeUrl: 'RemoveSpecifications',
    // // //     options: { noAddNew: true },
    // // //     // helperKey: 'values',
    // // //     pageType: 'form',
    // // //     parent: 'category',
    // // //     options: {},
    // // //     // sort: { 'cDate': -1 },
    // // //     // addNew: -1,
    // // //     image: '/images/covers/11.jpg',
    // // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // // //     headers: [
    // // //         { col: '6', key: 'type', type: 'TextInput', information: { label: 'Type', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'Title', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '6', type: 'SelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // // //         { col: '6', key: 'values', type: 'TextInput', information: { label: '{{lang}}values', placeholder: '{{lang}}values', required: true }, showMain: true },
    // // //         { col: '6', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // // //         { col: '6', key: 'sufix', type: 'TextInput', information: { label: '{{lang}}Sufix', placeholder: '{{lang}}sufix', required: true }, showMain: true },
    // // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },

    // // //     ],

    // // // },


    // // // city: {
    // // //     key: 'City',
    // // //     title: 'Cities',
    // // //     description: 'Cities list',
    // // //     fetchUrl: 'getAllCities',
    // // //     addUrl: 'addCities',
    // // //     editUrl: 'addCities',
    // // //     removeUrl: 'RemoveCities',
    // // //     options: { noAddNew: true },
    // // //     // helperKey: 'values',
    // // //     pageType: 'form',
    // // //     parent: 'Countries',
    // // //     options: {},
    // // //     // sort: { 'cDate': -1 },
    // // //     // addNew: -1,
    // // //     image: '/images/covers/11.jpg',
    // // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // // //     headers: [
    // // //         { col: '6', key: 'name', type: 'TextInput', information: { label: 'Name', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '6', type: 'SelectInput', key: 'country', information: { label: '{{lang}}Countries', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // // //     ],

    // // // },


    // // // countries: {
    // // //     key: 'Countries',
    // // //     title: 'Countries',
    // // //     description: 'Countries list',
    // // //     fetchUrl: 'getAllCountries',
    // // //     addUrl: 'addCountries',
    // // //     editUrl: 'addCountries',
    // // //     removeUrl: 'removeCountries',
    // // //     options: { noAddNew: true },
    // // //     // helperKey: 'values',
    // // //     pageType: 'form',
    // // //     parent: 'Countries',
    // // //     options: {},
    // // //     // sort: { 'cDate': -1 },
    // // //     // addNew: -1,
    // // //     image: '/images/covers/11.jpg',
    // // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // // //     headers: [
    // // //         { col: '12', key: 'name', type: 'TextInput', information: { label: 'Name', disabled: false, required: true }, showMain: true, inExport: true },
    // // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
    // // //     ],

    // // // },




    // permissions: {
    //     key: 'permissions',
    //     title: '{{lang}}permissions',
    //     description: 'permissions List',
    //     fetchUrl: 'getPermissions',
    //     removeUrl: 'removePermission',
    //     // editUrl: 'addValue',
    //     // removeUrl: 'removeValue',
    //     pageType: 'form',
    //     page: 'permissions',
    //     parent: 'cartable',
    //     image: '/images/icons/permission.png',
    //     addNew: '/admin/permission',
    //     hideFilter: true,
    //     headers: [
    //         // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
    //         { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

    //         { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


    //     ]
    // },


    // permission: {
    //     key: 'permission',
    //     title: 'permission',
    //     description: 'permission List',
    //     fetchUrl: 'getPermission',
    //     addUrl: 'addPermission',
    //     editUrl: 'addPermission',
    //     // removeUrl: 'removePermission',
    //     pageType: 'permissions',
    //     page: 'permissions',
    //     permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
    //     permissionParent: 'permissions',
    //     // parent: 'admin',
    //     hidePage: true,
    //     image: '/images/covers/dashboards.jpg',

    //     headers: [
    //         { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
    //         { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


    //     ]
    // },
    // // settings: {
    // //     key: 'settings',
    // //     title: '{{lang}}settings',
    // //     description: 'settings List',
    // //     // fetchUrl: 'getSettings',

    // //     // removeUrl: 'removePermission',
    // //     pageType: 'settings',
    // //     page: 'settings',

    // //     parent: 'admin',
    // //     hidePage: true,
    // //     image: '/images/covers/dashboards.jpg',

    // //     // headers: [
    // //     //     { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
    // //     //     { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


    // //     // ]
    // // },


    // // Products: {
    // //     key: 'Products',
    // //     title: 'Products',
    // //     description: 'Products list',
    // //     fetchUrl: 'getProducts',
    // //     addUrl: 'addProduct',
    // //     editUrl: 'addProduct',
    // //     removeUrl: 'removeProduct',
    // //     options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'products',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/11.jpg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'Title', disabled: false, required: true }, showMain: true, inExport: true },
    // //         { col: '6', type: 'SelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: true }, showMain: false },
    // //         { col: '6', type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
    // //         { col: '6', type: 'PriceInput', key: 'price', information: { label: '{{lang}}Price', placeholder: '{{lang}}Price', required: true }, hideInfilter: true, showMain: true },
    // //         { type: 'TextInput', key: 'priceSettings.discount.type', col: '6', information: { label: '{{lang}}Discount Type', placeholder: '{{lang}}Discount Type', required: true }, showMain: true, },
    // //         { col: '6', type: 'PriceInput', key: 'priceSettings.discount.value', information: { label: '{{lang}}price discount value', placeholder: '{{lang}}price discount value', required: true }, hideInfilter: true, showMain: true },
    // //         { type: 'PriceInput', key: 'priceSettings.priceBeforeDiscount', col: '6', information: { label: '{{lang}}Price Before Discount', placeholder: '{{lang}}Price Before Discount', required: true }, showMain: true, },
    // //         { type: 'TextInput', key: 'priceSettings.currency', col: '6', information: { label: 'currency', placeholder: 'currency', required: true }, showMain: true, },
    // //         { col: '12', type: 'SelectInput', key: 'specifications', information: { label: '{{lang}}specifications', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}specifications', required: false }, showMain: false },
    // //         {
    // //             type: 'SubformInput',
    // //             key: 'colors',
    // //             col: '12',
    // //             information: {
    // //                 headers: [
    // //                     { type: 'TextInput', key: 'color', col: '6', information: { label: '{{lang}}Coler Label', placeholder: '{{lang}}Color Label', required: true }, showMain: true, },
    // //                     { type: 'TextInput', key: 'name', col: '6', information: { label: '{{lang}}Color Name', placeholder: '{{lang}}Color Name', required: true }, showMain: true, },
    // //                     { type: 'TextInput', key: 'hex', col: '6', information: { label: '{{lang}}Color Hex Code', placeholder: '{{lang}}Color Hex Code', required: true }, showMain: true, },
    // //                 ],
    // //                 placeholder: '{{lang}}placeholders.insertInformation',
    // //                 required: true,
    // //             },
    // //             showMain: true
    // //         },
    // //         { key: 'images', type: 'ImageInput', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    // //         { key: 'cover', type: 'ImageInput', col: '12', information: { label: '{{lang}}cover', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
    // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },

    // //     ],

    // // },




    // // questions: {
    // //     key: 'froum',
    // //     title: 'سوالات',
    // //     description: 'لیست سوالات',
    // //     fetchUrl: 'getQuestions',
    // //     addUrl: 'postQuestion',
    // //     editUrl: 'postQuestion',
    // //     removeUrl: 'removeQuestion',
    // //     options: { noAddNew: false },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'froum',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/8.jpg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true } },
    // //         { col: '6', type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
    // //         { col: '6', type: 'SelectInput', key: 'category', information: { label: '{{lang}}category', updateAfterSelect: true, isSearchable: true, address: 'getContents', filter: { page: 'AcademyCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //         { col: '6', key: 'votes', type: 'NumberInput', information: { label: '{{lang}}votes', placeholder: '{{lang}}votes', required: false }, hideComponent: true, showMain: false },
    // //         { col: '6', key: 'answers', type: 'NumberInput', information: { label: '{{lang}}answers', placeholder: '{{lang}}answers', required: false }, hideComponent: true, },
    // //         { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
    // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
    // //         {
    // //             key: 'major',
    // //             type: 'SelectInput',
    // //             col: '6',
    // //             information: {
    // //                 label: '{{lang}}رشته ها',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "ریاضی", value: 'ریاضی' },
    // //                     { title: 'تجربی', value: 'تجربی' },
    // //                     { title: 'انسانی', value: 'انسانی' },
    // //                 ],
    // //                 required: true

    // //             },
    // //             showMain: true
    // //         },


    // //         {
    // //             key: 'grade',
    // //             type: 'SelectInput',
    // //             col: '6',
    // //             information: {
    // //                 label: '{{lang}}مقطع تحصیلی',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "دهم", value: 'دهم' },
    // //                     { title: 'یازدهم', value: 'یازدهم' },
    // //                     { title: 'دوازدهم', value: 'دوازدهم' },
    // //                 ],
    // //                 required: true
    // //             },
    // //             showMain: false
    // //         },

    // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
    // //     ],

    // // },


    // // messages: {
    // //     key: 'message',
    // //     title: 'all message',
    // //     description: 'we have messages here',
    // //     fetchUrl: 'getMessages',
    // //     addUrl: 'postMessage',
    // //     removeUrl: 'removeMessage',
    // //     // options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'messages',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/7.jpg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
    // //         { col: '6', type: 'SwitchInput', key: 'public', information: { label: '{{lang}}public', type: 'local', items: [{ value: 'public', title: 'public' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: false },
    // //         { col: '6', type: 'MultiSelectInput', key: 'users', information: { label: '{{lang}}Users', updateAfterSelect: true, isSearchable: true, address: 'userGetAll', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
    // //         { col: '12', key: 'message', type: 'TextAreaInput', information: { label: '{{lang}}message', placeholder: '{{lang}}message', required: true }, showMain: true },
    // //     ],
    // // },



    // // contents: {
    // //     key: 'content',
    // //     title: 'contents',
    // //     description: 'contents list',
    // //     fetchUrl: 'getContents',
    // //     addUrl: 'postContent',
    // //     removeUrl: 'removeContent',
    // //     options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/16.jpeg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

    // //     headers: [
    // //         { col: '6', key: 'values.contentTitle', type: 'TextInput', information: { label: 'Page', disabled: false, required: false }, showMain: true, inExport: true },
    // //         { col: '6', key: 'values.title', type: 'TextInput', information: { label: 'Title', disabled: false, required: false }, showMain: true, inExport: true },
    // //         { col: '12', key: 'values.slug', type: 'TextInput', information: { label: 'Slug', disabled: false, required: false }, showMain: true, inExport: true },
    // //     ],

    // // },





    // // classroom: {
    // //     key: 'classroom',
    // //     title: 'کلاس‌ها',
    // //     description: 'لیست کلاس‌ها',
    // //     fetchUrl: 'getClassrooms',
    // //     addUrl: 'postClassroom',
    // //     removeUrl: 'removeClassroom',
    // //     options: { noAddNew: true },
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/16.jpeg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { key: 'values.image', type: 'ImageInput', col: '6', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
    // //         { col: '6', type: 'DateInput', key: 'chooseDate', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: true, disabled: false } },
    // //         { col: '12', key: 'title', type: 'TextInput', information: { label: 'TITLE', disabled: false, required: true }, showMain: true, inExport: true },
    // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}DESCRIPTION', placeholder: '{{lang}}inser', required: false } },
    // //         { col: '6', key: 'family', type: 'TextInput', information: { label: 'FAMILY', required: true }, showMain: true, inExport: true },
    // //         { col: '6', key: 'name', type: 'TextInput', information: { label: 'NAME', required: true }, showMain: true, },
    // //     ],

    // // },


    // // wallpapers: {
    // //     key: 'wallpapers',
    // //     page: 'wallpapers',

    // //     title: 'بنر‌ها',
    // //     description: 'لیست بنر‌ها',
    // //     fetchUrl: 'getAllWallpaper',
    // //     addUrl: 'postWallpaper',
    // //     removeUrl: 'removeWallpaper',
    // //     options: { noAddNew: true },
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // addNew: -1,
    // //     image: '/images/covers/16.jpeg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
    // //         {
    // //             key: 'values.page',
    // //             type: 'SelectInput',
    // //             col: '12',
    // //             information: {
    // //                 label: '{{lang}}page',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "login", value: 'login' },
    // //                     { title: 'addWiki', value: 'addWiki' },
    // //                     { title: 'addThing', value: 'addThing' },
    // //                     { title: 'addApplet', value: 'addApplet' },
    // //                     { title: 'addProfile', value: 'addProfile' },

    // //                 ]
    // //             },
    // //         },
    // //     ],

    // // },


    // // test: {
    // //     key: 'test',
    // //     title: 'آزمون‌ها',
    // //     description: 'لیست آزمون‌ها',
    // //     fetchUrl: 'getAllTests',
    // //     addUrl: 'postTest',
    // //     removeUrl: 'removeTest',
    // //     options: { noAddNew: true },
    // //     pageType: 'form',
    // //     parent: 'content',
    // //     options: {},
    // //     // addNew: -1,
    // //     image: '/images/covers/16.jpeg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}DESCRIPTION', placeholder: '{{lang}}inser', required: false } },
    // //         { col: '12', type: 'DateInput', key: 'date', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: true, disabled: false } },
    // //         {
    // //             type: 'SubformInput',
    // //             key: 'links',
    // //             col: '12',
    // //             information: {
    // //                 headers: [
    // //                     { type: 'TextInput', key: 'label', col: '6', information: { label: '{{lang}}label', placeholder: '{{lang}}value', required: true }, showMain: true, },
    // //                     { type: 'TextInput', key: 'link', col: '6', information: { label: '{{lang}}link', placeholder: '{{lang}}value', required: true }, showMain: true, },
    // //                 ],
    // //                 placeholder: '{{lang}}placeholders.insertInformation',
    // //                 required: true,
    // //             }
    // //         },
    // //     ],


    // // },

    // // leitnerbox: {
    // //     key: 'leitnerbox',
    // //     title: 'لاینتر',
    // //     description: 'سوالات لایتنر',
    // //     fetchUrl: 'getAllleitners',
    // //     addUrl: 'postLeitners',
    // //     removeUrl: 'removeLeitners',
    // //     options: { noAddNew: true },
    // //     pageType: 'form',
    // //     parent: 'leitnerbox',
    // //     options: {},
    // //     // addNew: -1,
    // //     image: '/images/covers/16.jpeg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [

    // //         {
    // //             key: 'major',
    // //             type: 'SelectInput',
    // //             col: '6',
    // //             information: {
    // //                 label: '{{lang}}رشته ها',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "ریاضی", value: 'ریاضی' },
    // //                     { title: 'تجربی', value: 'تجربی' },
    // //                     { title: 'انسانی', value: 'انسانی' },
    // //                 ],
    // //                 required: true

    // //             },
    // //             showMain: true
    // //         },

    // //         {
    // //             key: 'course',
    // //             type: 'SelectInput',
    // //             col: '6',
    // //             information: {
    // //                 label: '{{lang}}درس ها',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "فیزیک", value: 'فیزیک' },
    // //                     { title: 'ریاضی', value: 'ریاضی' },
    // //                     { title: 'زیست', value: 'زیست' },
    // //                 ],
    // //                 required: true
    // //             },
    // //             showMain: true
    // //         },

    // //         {
    // //             key: 'grade',
    // //             type: 'SelectInput',
    // //             col: '12',
    // //             information: {
    // //                 label: '{{lang}}مقطع تحصیلی',
    // //                 placeholder: '{{lang}}insert',
    // //                 type: 'local',
    // //                 items: [
    // //                     { title: "دهم", value: 'دهم' },
    // //                     { title: 'یازدهم', value: 'یازدهم' },
    // //                     { title: 'دوازدهم', value: 'دوازدهم' },
    // //                 ],
    // //                 required: true
    // //             },
    // //             showMain: false
    // //         },


    // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}BODY', placeholder: '{{lang}}body', required: true }, showMain: false },

    // //         { col: '12', key: 'answer', type: 'EditorInput', information: { label: '{{lang}}ANSWER', placeholder: '{{lang}}ANSWER', required: true }, showMain: false },
    // //     ],
    // // },



    // // saveleitner: {
    // //     key: 'froum4',
    // //     title: 'saved leitner',
    // //     description: 'saved leitner list',
    // //     fetchUrl: 'getSaveQuestion',
    // //     addUrl: 'saveLeitners',
    // //     removeUrl: 'removeSaveQuestion',
    // //     // options: { noAddNew: true },
    // //     // helperKey: 'values',
    // //     pageType: 'form',
    // //     parent: 'leitnerbox',
    // //     options: {},
    // //     // sort: { 'cDate': -1 },
    // //     // addNew: -1,
    // //     image: '/images/covers/7.jpg',
    // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    // //     headers: [
    // //         { type: 'SelectInput', key: 'question', col: '12', information: { label: '{{lang}}Question', updateAfterSelect: true, isSearchable: true, address: 'getAllleitners', filter: {}, fields: { title: 'title', value: 'title' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.questions', required: true }, showMain: true },
    // //     ],

    // // },


}


export { carbonPages, carbonSections }